import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { formatAxisCurrency, formatCurrency } from './dashboardUtils.js'

const RevenueChart = ({ data = [], granularity = 'monthly', loading = false, height = 320 }) => {
  const pointCount = data.length
  const useAngledLabels = pointCount > 8 || granularity === 'daily'
  const tickFontSize = pointCount > 20 ? 9 : 10
  const xAxisHeight = useAngledLabels ? 72 : 36
  const maxValue = data.reduce((max, row) => Math.max(max, row.paid || 0, row.due || 0), 0)
  const yAxisWidth = maxValue >= 100000 ? 56 : 48

  if (loading) {
    return (
      <div className="flex items-center justify-center" style={{ height }}>
        <div className="w-8 h-8 border-4 border-brand border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!data.length) {
    return (
      <div className="flex items-center justify-center text-secondary text-sm" style={{ height }}>
        No revenue data for the selected period
      </div>
    )
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 8, right: 16, left: 4, bottom: useAngledLabels ? 8 : 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis
          dataKey="period"
          angle={useAngledLabels ? -35 : 0}
          textAnchor={useAngledLabels ? 'end' : 'middle'}
          height={xAxisHeight}
          interval={pointCount > 24 ? Math.ceil(pointCount / 12) - 1 : 0}
          tick={{ fontSize: tickFontSize, fill: '#6b7280' }}
          tickMargin={8}
        />
        <YAxis
          width={yAxisWidth}
          tick={{ fontSize: 11, fill: '#6b7280' }}
          tickFormatter={formatAxisCurrency}
          domain={[0, 'auto']}
          allowDecimals={false}
          tickCount={6}
        />
        <Tooltip
          formatter={(value) => formatCurrency(value)}
          labelFormatter={(label) => `Period: ${label}`}
          contentStyle={{ fontSize: 12 }}
        />
        <Legend wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
        <Line
          type="monotone"
          dataKey="paid"
          stroke="#10b981"
          strokeWidth={2}
          dot={pointCount <= 31 ? { r: 3 } : false}
          activeDot={{ r: 5 }}
          name="Paid Amount"
        />
        <Line
          type="monotone"
          dataKey="due"
          stroke="#f97316"
          strokeWidth={2}
          dot={pointCount <= 31 ? { r: 3 } : false}
          activeDot={{ r: 5 }}
          name="Due Amount"
        />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default RevenueChart
